export const LandingPagePTBRTranslations = {
  landingPageHeadTitle: '4intelligence',
  landingPageHeadDescription:
    'Entenda como a Inteligência Artificial da 4intelligence pode ajudar sua empresa a construir projeções precisas e tomar melhores decisões, baseando-se em dados. Conheça nossas soluções!',
  landingPageSlogan:
    'Construa projeções precisas e tome decisões melhores, baseando-se em dados, através da nossa plataforma.',
  landingPageDownButtonLabel: 'Botão para ir para o próximo conteúdo abaixo',
  landingPagePlatformSubtitle: 'Nossa plataforma',
  landingPagePlatformTitle: 'Uma ferramenta, infinitas possibilidades',
  landingPagePlatformDescription1:
    'A plataforma foi pensada e desenvolvida para gestores de diferentes áreas de negócios, sendo a solução perfeita quando o assunto são os desafios relacionados a projeções de mercado e análises de probabilidade.',
  landingPagePlatformDescription2:
    'Além disso, nossa ferramenta conta com uma base de dados integrada que enriquece o aprendizado da nossa inteligência artificial.',
  landingPagePlatformFS: 'Base de dados integrada',
  landingPagePlatformModels: 'Motor de Modelagem',
  landingPageModelingSubtitle: 'Plataforma de projeções',
  landingPageModelingTitle:
    'Para qualquer tipo de previsão, a 4intelligence tem a solução!',
  landingPageModelingDescription:
    'Nossa plataforma consegue solucionar qualquer desafio de negócio.',
  landingPageModelingTimeSubtitle: 'Série de tempo',
  landingPageModelingTimeTitle: 'Projeções',
  landingPageModelingTimeDescription:
    'Usufrua da nossa inteligência artificial para analisar um grande volume de dados a fim de impulsionar o futuro do seu negócio.',
  landingPageModelingTimeImageAlt: 'Gráfico de séries temporais',
  landingPageModelingClassificationSubtitle: 'Classificação',
  landingPageModelingClassificationTitle: 'Probabilidades',
  landingPageModelingClassificationDescription:
    'Com nossa inteligência de dados é possível resolver diferentes tipos de problemas de probabilidades de forma clara, precisa e interpretável.',
  landingPageModelingClassificationImageAlt:
    'Gráfico do método classificação de aprendizado de máquina',
  landingPageModelingLocationSubtitle: 'Localização',
  landingPageModelingLocationTitle: 'Geolocalização',
  landingPageModelingLocationDescription:
    'Utilize nossa inteligência artificial de classificação para solucionar os desafios nos quais a localização é um indicador relevante.',
  landingPageModelingLocationImageAlt: 'Mapa de geolocalização',
  landingPageDepartmentSubtitle: 'Para cada setor',
  landingPageDepartmentTitle: 'Nós temos a solução para o seu negócio',
  landingPageDepartmentSolution: 'Nós temos a solução',
  landingPageDepartmentType: 'Setor de ',
  landingPageDepartmentIndustries: 'Indústrias',
  landingPageDepartmentIndustriesDescription:
    'Usufrua do poder da inteligência artificial da 4intelligence para:',
  landingPageDepartmentIndustriesList1: 'Prever demanda.',
  landingPageDepartmentIndustriesList2: 'Otimizar o estoque.',
  landingPageDepartmentIndustriesList3: 'Gerenciar Market Share.',
  landingPageDepartmentIndustriesList4:
    'Definir estratégia de repasse de custo e aumento de preço.',
  landingPageDepartmentIndustriesList5: 'Projetar preço de commodities.',
  landingPageDepartmentIndustriesList6: 'E muito mais!',
  landingPageDepartmentIndustriesImageAlt:
    'Tela da solução para o setor de indústrias',
  landingPageDepartmentAgribusiness: 'Agronegócios',
  landingPageDepartmentAgribusinessDescription:
    'O poder dos dados aliado a inteligência artificial são a chave para:',
  landingPageDepartmentAgribusinessList1:
    'Projetar a produtividade durante a safra.',
  landingPageDepartmentAgribusinessList2:
    'Projetar o preço de commodities agrícolas.',
  landingPageDepartmentAgribusinessList3: 'Acompanhar o ritmo de safra.',
  landingPageDepartmentAgribusinessList4:
    'Otimizar a gestão de estoque de insumos agrícolas.',
  landingPageDepartmentAgribusinessList5: 'Otimizar a frota.',
  landingPageDepartmentAgribusinessList6: 'E muito mais!',
  landingPageDepartmentAgribusinessImageAlt:
    'Tela da solução para o setor de agronegócios',
  landingPageDepartmentConcessionaires: 'Concessionárias',
  landingPageDepartmentConcessionairesDescription:
    'Aperfeiçoe os processos decisórios utilizando a inteligência artificial para:',
  landingPageDepartmentConcessionairesList1:
    'Projetar fluxo de carros em rodovias.',
  landingPageDepartmentConcessionairesList2:
    'Antecipar o risco de inadimplência.',
  landingPageDepartmentConcessionairesList3: 'Criar estratégias de expansão.',
  landingPageDepartmentConcessionairesList4:
    'Explicar as variáveis que impactam no planejamento estratégico.',
  landingPageDepartmentConcessionairesList5:
    'Aumentar transparecia com investidor.',
  landingPageDepartmentConcessionairesList6: 'E muito mais!',
  landingPageDepartmentConcessionairesImageAlt:
    'Tela da solução para o setor de concessionárias',
  landingPageDepartmentLogistics: 'Logística',
  landingPageDepartmentLogisticsDescription:
    'Utilize a inteligência artificial como peça fundamental para:',
  landingPageDepartmentLogisticsList1: 'Projetar o preço do frete.',
  landingPageDepartmentLogisticsList2: 'Projetar o preço do diesel.',
  landingPageDepartmentLogisticsList3:
    'Projetar a oferta e a demanda dos produtos.',
  landingPageDepartmentLogisticsList4:
    'Projetar a capacidade adequada de armazenagem.',
  landingPageDepartmentLogisticsList5:
    'Otimizar o transporte através da melhor rota.',
  landingPageDepartmentLogisticsList6: 'E muito mais!',
  landingPageDepartmentLogisticsImageAlt:
    'Tela da solução para o setor de logística',
  landingPageDepartmentRetail: 'Varejo',
  landingPageDepartmentRetailDescription:
    'A inteligência artificial é a sua maior aliada para:',
  landingPageDepartmentRetailList1: 'Melhorar a alocação de pessoas e ativos.',
  landingPageDepartmentRetailList2:
    'Definir o melhor local para abrir ou fechar uma loja.',
  landingPageDepartmentRetailList3:
    'Definir qual a saturação do mercado no local.',
  landingPageDepartmentRetailList4:
    'Analisar aspectos de canibalização de concorrentes.',
  landingPageDepartmentRetailList5:
    'Projetar o potencial de faturamento do varejo.',
  landingPageDepartmentRetailList6: 'E muito mais!',
  landingPageDepartmentRetailImageAlt: 'Tela da solução para o setor de varejo',
  landingPageAboutSubtitle: 'O que fazemos',
  landingPageAboutTitle: 'Solução de inteligência de dados',
  landingPageAboutDescription:
    'Oferecemos uma solução que une ciência de dados e inteligência artificial voltada para resolver desafios que envolvem previsões e tomadas de decisões estratégicas.',
  landingPageAboutDatabaseTitle:
    'Informações econômicas prontas para o seu negócio',
  landingPageAboutDatabaseDescription:
    'Tenha acesso ao nosso banco de dados completo e garanta a explicabilidade das suas projeções.',
  landingPageAboutApplicationTitle:
    'Plataforma inovadora, completa e  intuitiva',
  landingPageAboutApplicationDescription:
    'Conte com a ajuda de especialistas em inteligência econômica garantindo sempre a melhor experiência.',
  landingPageAboutAgilityTitle:
    'Simplicidade e agilidade para tomadas de decisão',
  landingPageAboutAgilityDescription:
    'Tenha acesso a resultados instantâneos, traduzidos em insights objetivos, com apenas um clique.',
  landingPageCasesSubtitle: 'Cases',
  landingPageCasesTitle: 'Descubra como a 4intelligence ajudou as empresas',
  landingPageStartSubtitle: 'Comece aqui',
  landingPageStartTitle:
    'A melhor solução para o seu negócio, em uma única plataforma',
  landingPageStartDescription:
    'Descubra como nossa solução de inteligência de dados de ponta-a-ponta ajuda grandes empresas a tomarem decisões precisas',
  landingPageStartVideoThumbImageAlt:
    'Tela do nosso produto com duas seções: models e feature store',
  landingPageStartVideoTitle: 'Vídeo sobre nossa empresa',
  landingPageContactTitle: 'Qual decisão você precisa tomar hoje?',
  landingPageContactDescription:
    'Nossa plataforma irá te ajudar a mapear suas principais alavancas de crescimento e redução de risco',
};
